import { useTranslation } from 'react-i18next';
// import icon2 from '../../assets/banner/home/icon_hero_1.svg';
// import icon1 from '../../assets/banner/home/icon_hero_2.svg';
// import icon_x from '../../assets/banner/home/icon_hero_x.svg';

const SectionHero = () => {
    const { t, i18n } = useTranslation();

    return (
        <>
            <section className='hero'>
                <div className='hero-content'>
                    <h1 className='font-bauhaus-medium'>{t('hero.title')}</h1>
                    <p className='font-tomorrow'>{t('hero.description')}</p>
                    <div className='hero-buttons'>
                        <button className='btn-primary cursor-pointer'>{t('hero.download')}</button>
                        <button className='btn-secondary cursor-pointer'>{t('hero.contact')}</button>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SectionHero;